import { checkFeature } from './featureFlag';
import { FeatureFlagResponseData } from '../interfaces/featureFlags';

/**
 * Feature flag gating browser-direct Supergraph enrichment (live learner
 * counts, detail enrichment, Attendance/Roster tabs).
 *
 * The deployed Supergraph only allows any-localhost origins (it skips the
 * per-origin clientId check for localhost); the Grimsby domains are not yet
 * registered in AwsTcPlatformSupergraph frontendClients.ts, so the feature
 * only works during local dev. The flag in public/features.json is therefore
 * scoped to `open_hosts: ["localhost"]` — enabled on localhost, off on every
 * deployed stage until the origins are registered.
 */
export const SUPERGRAPH_ENRICHMENT_FEATURE = 'supergraph-enrichment';

/**
 * Returns true when the current host is explicitly permitted to call the
 * Supergraph directly.
 *
 * Fails CLOSED: this gate controls POSTing the user's raw Gandalf idToken
 * directly to the Supergraph, which must only happen on hosts the flag
 * explicitly allows (localhost today). {@link checkFeature} on its own fails
 * OPEN — it returns true when the features config is missing OR when this
 * flag entry is absent — so if features.json failed to load or the entry were
 * ever dropped, the feature would silently turn on in prod. We therefore
 * require the flag entry to be present before delegating; a missing config or
 * entry leaves the feature disabled. Once the entry exists, checkFeature
 * correctly evaluates its host scoping (open_hosts).
 */
export const isSupergraphEnrichmentEnabled = (
    featureFlags: FeatureFlagResponseData | null | undefined,
): boolean => {
    const featureEntry =
        featureFlags?.features?.[SUPERGRAPH_ENRICHMENT_FEATURE];
    if (!featureEntry) {
        return false;
    }
    return !!checkFeature(
        '',
        { featureName: SUPERGRAPH_ENRICHMENT_FEATURE },
        featureFlags?.features,
    );
};
